import ApiService from "@/common/api.service";
import {
  FETCH_COEFFICIENT_RELIABILITY_QUARTERLY,
  FETCH_COEFFICIENT_RELIABILITY,
  UPDATE_COEFFICIENT_RELIABILITY
} from "../actions.type";
import {
  FETCH_COEFFICIENT_RELIABILITY_START,
  SET_COEFFICIENT_RELIABILITY,
  SET_COEFFICIENT_RELIABILITY_QUARTERLY
} from "../mutations.type";

const state = {
  coefficientReliability: {
    data: [],
    quarterly: {},
    isLoading: false
  }
};

const getters = {
  coefficientReliability: state => state.coefficientReliability.data,
  coefficientReliabilityQuarterly: state =>
    state.coefficientReliability.quarterly,
  coefficientReliabilityIsLoading: state =>
    state.coefficientReliability.isLoading
};

const actions = {
  [FETCH_COEFFICIENT_RELIABILITY](context, year) {
    context.commit(FETCH_COEFFICIENT_RELIABILITY_START);
    return ApiService.get(`/coefficient/reliability/${year}`).then(
      ({ data }) => {
        context.commit(SET_COEFFICIENT_RELIABILITY, data);
      }
    );
  },
  [FETCH_COEFFICIENT_RELIABILITY_QUARTERLY](context, [year, quarter, fleet]) {
    context.commit(FETCH_COEFFICIENT_RELIABILITY_START);
    return ApiService.get(`/coefficient/reliability/${year}/${quarter}/${fleet}`).then(
      ({ data }) => {
        context.commit(SET_COEFFICIENT_RELIABILITY_QUARTERLY, data);
        return data;
      }
    );
  },
  [UPDATE_COEFFICIENT_RELIABILITY](context, payload) {
    return ApiService.post("/coefficient/reliability/update", payload);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_COEFFICIENT_RELIABILITY_START](state) {
    state.coefficientReliability.isLoading = true;
  },
  [SET_COEFFICIENT_RELIABILITY](state, data) {
    state.coefficientReliability.data = data.items;
    state.coefficientReliability.isLoading = false;
  },
  [SET_COEFFICIENT_RELIABILITY_QUARTERLY](state, data) {
    state.coefficientReliability.quarterly = data;
    state.coefficientReliability.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
